import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}companies/`;

export default {
  getAll(params = {}, companyId = null) {
    return axios.get(API_URL, {
      params,
      headers: buildHeaders({}, companyId),
    });
  },

  get(id, companyId = null) {
    return axios.get(`${API_URL}${id}`, {
      headers: buildHeaders({}, companyId),
    });
  },

  getCurrent(companyId = null) {
    return axios.get(`${API_URL}current`, {
      headers: buildHeaders({}, companyId),
    });
  },

  // JSON by default (less likely to trip Imunify360 bot-protection).
  // Use multipart only when uploading files.
  create(data, companyId = null) {
    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;

    return axios.post(API_URL, data, {
      headers: buildHeaders({}, { companyId, multipart: isFormData }),
    });
  },

  // Update:
  // - If you're sending FormData => POST + _method=PUT
  // - If JSON only => use axios.put with buildHeaders()
  update(id, data, companyId = null) {
    const isFormData =
      typeof FormData !== "undefined" && data instanceof FormData;

    if (isFormData) {
      data.set("_method", "PUT");
      return axios.post(`${API_URL}${id}`, data, {
        headers: buildHeaders({}, { companyId, multipart: true }),
      });
    }

    return axios.put(`${API_URL}${id}`, data, {
      headers: buildHeaders({}, companyId),
    });
  },

  changePlan(id, data, companyId = null) {
    return axios.post(`${API_URL}${id}/change-plan`, data, {
      headers: buildHeaders({}, companyId),
    });
  },

  getModuleOverrides(id, companyId = null) {
    return axios.get(`${API_URL}${id}/module-overrides`, {
      headers: buildHeaders({}, companyId),
    });
  },

  updateModuleOverrides(id, data, companyId = null) {
    return axios.put(`${API_URL}${id}/module-overrides`, data, {
      headers: buildHeaders({}, companyId),
    });
  },

  delete(id, companyId = null) {
    return axios.delete(`${API_URL}${id}`, {
      headers: buildHeaders({}, companyId),
    });
  },

  // ⚠️ remove the leading slash to respect baseURL
  bulkDelete(ids, companyId = null) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders({}, companyId) }
    );
  },

  export(params = {}, format = "excel", companyId = null) {
    return axios.get(`${API_URL}export`, {
      params: { ...params, format },
      headers: buildHeaders({}, companyId),
      responseType: "blob",
    });
  },
};
